import { React, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
// import { motion } from "framer-motion";
// import Video from "./Video";
// import { ControlBar, Player } from "video-react";

export default function Intro() {

    // let playerRef = null;

    const [introShown, setIntroShown] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);
    // const [player, setPlayer] = useState(null);

    // useEffect(() => {
    //     if (playerRef) {
    //         playerRef.subscribeToStateChange(handleBind);
    //     }
    // });

    const history = useHistory();

    // function handleBind(state) {

    //     // setstate(state);
    //     // console.log(state);

    //     if (state.currentTime > 1.5) {
    //         setIntroShown(true);
    //     }
    // }

    const toggleFullScreen = () => {

        console.log("toggleFullScreen");

        if (document.fullScreenElement ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
            }
            else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            }
            else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
            setFullscreen(true);
        }
        else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            }
            else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            }
            else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
            setFullscreen(false);
        }
    };

    const handleScreenClick = () => {
        history.push("/category/all-markets");
    };

    // const dispose = () => {
    //     player.dispose();
    // };

    // const playerReady = (player) => {

    //     setPlayer(player);

    //     /*player.on('dispose', () => {
    //         console.log('player dispose');
    //     });*/
    // };

    return (
        <div className={"h-100 bg-black"}>

            <div
                className={"m-2"}
                style={{
                    position: "absolute",
                    zIndex: 9999
                }}
            >
                <a
                    href="#"
                    className={"btn btn-primary"}
                    onClick={() => {
                        toggleFullScreen();
                    }}
                >
                    Full Screen
                </a>
            </div>

            <video muted autoPlay loop style={{ width: '100%', height: '100%' }}>
                <source src={`http://localhost:9090/video/ProjectShowcaseIntro.mp4`} type="video/mp4" />
                <source src="https://s3.us-east-1.amazonaws.com/s3.museum.amesconstruction.com/d-project-showcase/1080/ProjectShowcaseIntro.mp4" type="video/mp4" />
            </video>
                
            {/* No longer using videojs here because it causes more problems than it solves. Default HTML5 player is better. */}
            {/* <Video onReady={playerReady} autoPlay={true} loop={true} options={{
                sources: [
                    {
                        src: env === 'PROD' ? `http://localhost:9090/ProjectShowcase.mp4` : `https://s3.us-east-1.amazonaws.com/s3.museum.amesconstruction.com/d-project-showcase/1080/ProjectShowcase.mp4`,
                        type: "video/mp4"
                    }
                ]
            }} /> */}

            <div style={{
                top: 0,
                right: 0,
                position: "absolute",
                width: "100%",
                height: "100%"
            }}>

                <Container
                    fluid
                    className={"h-100"}
                    onClick={handleScreenClick}
                >
                    <Row className={"h-100"}>
                        <Col className={"h-100 text-center d-flex align-items-center justify-content-center"}>

                            {/* <If condition={introShown}> */}

                            <Link
                                className={`btn-intro ${introShown ? "opacity-100" : "opacity-0"}`}
                                to={"/category/all-markets"} /*onClick={dispose}*/
                            >
                                Touch Screen To Explore
                            </Link>

                            {/* </If> */}

                        </Col>
                    </Row>
                </Container>
            </div>

        </div>
    );
}
